export default __webpack_public_path__ + "static/media/Alexa 9781408316771.8944622a.jpg";